import { Code } from './code.enum';
import type { EventData, EventDescriptor, InputService, Modifiers } from './input.service';

export class InputEventBindContext {
	private em: InputService;

	private currentEventSymbols: symbol[] = [];

	constructor(service: InputService) {
		this.em = service;
	}

	on(
		code: Code | undefined,
		fn: (evt: EventData) => void,
		options?: Partial<{
			modifiers: Partial<Modifiers>;
			eventType: 'keydown' | 'keyup';
		}>
	): symbol {
		const eventDescriptor: EventDescriptor = {
			code,
			modifiers: {
				ctrl: options?.modifiers?.ctrl ?? false,
				shift: options?.modifiers?.shift ?? false,
				alt: options?.modifiers?.alt ?? false,
				meta: options?.modifiers?.meta ?? false,
			},
			eventType: options?.eventType ?? 'keydown',
		};
		const symbol = this.em.on(this, eventDescriptor, fn);
		this.currentEventSymbols.push(symbol);
		return symbol;
	}

	off(symbol: symbol): boolean {
		const index = this.currentEventSymbols.findIndex((currentEventSymbol) => currentEventSymbol === symbol);
		if (index > -1) {
			this.currentEventSymbols.splice(index, 1);
		}
		return this.em.off(this, symbol);
	}

	destroy() {
		this.currentEventSymbols.forEach((currentEventSymbol) => this.em.off(this, currentEventSymbol));
		this.currentEventSymbols = [];
	}

	/**
	 * @deprecated Use the {@link Code} enum directly.
	 */
	public Code = {
		...Code,
		AllKeys: undefined as undefined,
	};
}
